import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

// ts-expect-error queryKey
export const getPaymentInfo = async ({ queryKey }: JsonDataItem) => {
  const { data } = await baseQuery(`payment-info?customerID=${queryKey[1]}`);

  return data;
};
